import './jquery-extensions';
import './shippable-auto-complete';
import './app-cart';
import './app-address-book';
import './modernizr-custom'; // <html> element classes: touchevents + webp...
import {BODY_SCROLL_THRESHOLD} from "./constants";
import {isIOS, isLargeScreen} from "./device-detect";
import * as webauthn from "p360wsc-js/webauthn";
import {init as initPushNotifications} from "p360wsc-js/push_notifications/one-signal";
import * as paymentActions from "p360wsc-js/payments/actions";
import * as dl from "p360wsc-js/marketing/data_layer";
import * as forms from './forms';
import {init as initOrderTracking} from 'p360wsc-js/order-tracking';
import CookiePrompt from 'p360wsc-js/marketing/cookie-prompt';
import {init as initShippingProgress} from 'p360wsc-js/shipping-progress';

window.dataLayer = window.dataLayer || [];

// JavaScript Document
(function($) {
    $.fn.extend({
        provinceField: function() {
            // blocking this Sylius/Bundle/ShopBundle/Resources/private/js/sylius-province-field.js:14
            return void 0;
        }
    })
})(jQuery);

$('.radio-group').on('change', function(){
    const $self = $(this);
    if(!$self.data('radio-group')){
        return;
    }
    const $inputs = $('input[data-radio-group="'+ $self.data('radio-group') +'"]:checked');
    $inputs.each(function( index, element ) {
        const $element = $(element);
        if($element.val() !== $self.val()){
            $(element).prop('checked', false);
        }
    });

});

// -- show nav
$(document).on('click', '*[data-target="#primary-nav"]', function() {
    const nav = $('#primary-nav');
    if (nav.isInViewport('top')) {
        nav.toggleClass('nav--active');
        if (this.id === 'headerBtn') {
            nav.toggleClass('nav--mobile');
        }
    } else {
        ! nav.hasClass('nav--active') && nav.addClass('nav--active');
        if (this.id === 'headerBtn') {
            ! nav.hasClass('nav--mobile') && nav.addClass('nav--mobile');
        }
        window.scrollBy(0, $(window).scrollTop() * -1);
    }
});

// fixate body when needed
$(document).ready(() => {
    if ($('[data-fixate-body="1"]').length > 0) {
        $('body').toggleClass('body--fixed');
    }
});

document.addEventListener('app-modal', function(e) {
    let intent;
    const detail = e.detail;
    const target = detail.trigger;
    if (detail.open) {
        if (target.href) {
            intent = { type: 'link', href: target.href };
        }
        if (target.attributes.slug) {
            intent = { type: 'link', href: target.querySelector('a').href };
        }
        if (target.dataset.productId) {
            intent = { type: 'product', id: target.dataset.productId };
        }
    }

    if (intent) {
        const shippingLink = document.querySelector('#go-to-shipping-link');
        const newHref = new URL(shippingLink.href);
        newHref.searchParams.append('post_shipping_intent', "1");
        shippingLink.href = newHref.toString();
        shippingLink.addEventListener('click', function() {
            localStorage.setItem('post_shipping_intent', JSON.stringify(intent));
        });
    }
});

(function($) {
    var activeModal;
    // -- modals
    $(document).on('click', '*[data-modal]', function(e) {
        if (this.dataset.modal && this.dataset.modal !== "false") {
            const $modalTarget = $(this.dataset.modal);
            $modalTarget.toggleClass('modal--active');
            if (activeModal) {
                activeModal.removeClass('modal--active');
            }
            if ($modalTarget.hasClass('modal--active')) {
                activeModal = $modalTarget;
                $('.product-modal--active').each(function() {
                    $(this).removeClass('product-modal--active');
                });
            } else {
                activeModal = undefined;
            }
            var body = $('body');
            if (activeModal && !body.hasClass('body--fixed')) {
                body.addClass('body--fixed');
            } else {
                body.removeClass('body--fixed');
            }
            const modalEvent = new CustomEvent('app-modal', { detail: {
                    modal: $modalTarget.get(0),
                    open: $modalTarget.hasClass('modal--active'),
                    trigger: e.currentTarget
                }});
            document.dispatchEvent(modalEvent);
            return $(this).data('propagate-after-modal-closes') === 1;
        }
    });
})($);

$(document).on('click', '*[data-toggle-product]', function() {
  let _this = $(this);
  _this.toggleClass('btn--more-active');
  $(
    '*[data-product-option="' + _this.data('toggle-product') + '"]'
  ).toggleClass('hidden');
  return false;
});

// Cart side toggle
$(document).on('click', '#cartToggle', function() {
  var elMenuBtn = document.getElementById('headerBtn');
  if (elMenuBtn && !isElementVisible(elMenuBtn)) {
    $('.cart-side').toggleClass('cart-side--active');
    return false;
  }
});

// Click outside - hide cart or product detail
$(document).on('click', function(event) {
  var elMenuBtn = document.getElementById('headerBtn');
  if (elMenuBtn && !isElementVisible(elMenuBtn)) {
    if (
      !$(event.target).closest('#cartToggle').length &&
      !$(event.target).closest('.cart-side').length
    ) {
      if ($('.cart-side').is(':visible')) {
        $('.cart-side').removeClass('cart-side--active');
      }
    }
  }
  if (!$(event.target).closest('#productModal').length) {
    if ($('#productModal').is(':visible')) {
      $('#productModal').removeClass('product-modal--active');
      $('#productModalInner').empty();
    }
  }
});

// Main nav toggle
$(document).on('click', '#btnToggleMenu', function() {
  var elMenuBtn = document.getElementById('headerBtn');
  if (elMenuBtn && !isElementVisible(elMenuBtn)) {
    $('#primary-nav').toggleClass('nav--custom-active');
    return false;
  }
});

// Back button
$(document).on('click', '#back-button', function(event) {
  history.back();
  event.preventDefault();
});

// Login toggle
$(document).on('click', '*[data-btn-toggle-login]', function() {
  var elMenuBtn = document.getElementById('headerBtn');
  if (elMenuBtn && !isElementVisible(elMenuBtn)) {
    $('#form-login').addClass('login--active');
    $('#form-register').removeClass('login--active');
    $('#modal-login').toggleClass('modal--active');
    $('body').toggleClass('body--fixed');
    return false;
  }
});

// Register toggle
$(document).on('click', '#btnToggleRegister', function() {
  var elMenuBtn = document.getElementById('headerBtn');
  if (elMenuBtn && !isElementVisible(elMenuBtn)) {
    $('#form-login').toggleClass('login--active');
    $('#form-register').toggleClass('login--active');
    return false;
  }
});
// Register toggle
$(document).on('click', '[data-show-product-detail]', function(e) {
  const $elModal = document.getElementById('productModal');
  const $elModalInner = document.getElementById('productModalInner');
  if ($elModal) {
    $($elModal).addClass('product-modal--active');
    const $currentTarget = $(e.currentTarget);
    const $product = $($('li' + $currentTarget.data('show-product-detail')).html());
    const $img = $product.find('img');
    $img.attr('src', $img.data('detail-src'));
    $product
        .find('button[data-check-input]')
        .attr('data-check-input', $currentTarget.data('show-product-detail-selector'));
    const justAdded = $product.find('div.product-inserted');
    if(justAdded.length){
        justAdded.remove();
    }
    $($elModalInner)
      .empty()
      .html($product.html());
    return false;
  }
});
$(document).on('click', '#productModalClose, [data-product-modal-close]', function() {
  var elModal = document.getElementById('productModal');
  var elModalInner = document.getElementById('productModalInner');
  if (elModal) {
    $(elModal).removeClass('product-modal--active');
    $(elModalInner).empty();
    return false;
  }
});

// Toggle subnavigation
$(document).on('click', '.nav-item__toggle, .should-expand > .nav-item__link', function() {
  var closestCheckbox = $(this).closest('.nav-item').find('> .nav-item__chk');
  closestCheckbox.prop("checked", !closestCheckbox.prop("checked"));
  return false;
});

$(document).ready(function() {
  // Popups
  $('.tooltip').popup();
  $('.shippable-autocomplete').shippableAutoComplete();
});

$('#modal-login').on('submit', '.modal-content > *', function(e) {
    e.preventDefault();

    const $form = $(e.target);
    const data = $form.serialize();
    const action = $form.attr('action');
    const method = $form.attr('method');
    const $content = $(e.currentTarget);
    const $loading = $('<div class="ui active dimmer"><div class="ui loader"></div></div>');
    $content.prepend($loading);

    $.ajax({
        url: action,
        method: method,
        data: data
    }).done(function(data, textStatus, jqXhr) {
        if (jqXhr.responseJSON) {
            const redirect = jqXhr.responseJSON.redirect;
            if (redirect) {
                location.href = redirect;
            } else {
                location.reload();
            }
        } else {
            $content.html($(data).html());
            onLoadDom($content.parent());
        }
    }).fail(function() {
        location.reload();
    });
});

$('form[name=remember_card]').on('change', 'input', function(e) {
    $(e.target).closest('form')[0].submit();
});

$('form[name=other_settings]').on('change', 'input', function(e) {
    $(e.target).closest('form')[0].submit();
});

// -- Helper function for checking visibility
var isElementVisible = function isElementVisible(el) {
  return !!(el.offsetWidth || el.offsetHeight || el.getClientRects().length);
};

(function() {
  const $modal = $('#modal-payment-error');
  if ($modal.length === 0) {
    return;
  }

  setTimeout(function() {
    location.href = $modal.find('.btn').attr('href');
  }, 20000);
})();

(function() {
  const modal = $('[data-modal-interval]');
  if (modal.length === 0) {
    return;
  }
  const interval = modal.data('modal-interval') * 1000;
  function close() {
      modal.modal('hide');
  }

  setTimeout(function() {
      modal.modal('hide');
  }, interval);
})();

(function() {
    const $scrollTo = $('[data-scroll-to-this]').first();
    if ($scrollTo.length === 0) {
        return;
    }

    const scrollTop = $scrollTo.offset().top - $('header').height();
    $(document).scrollTop(scrollTop);
})();

$(document).on('click', '[data-check-input]', function(e) {
    const inputSelector = $(e.currentTarget).data('check-input');
    $(inputSelector).prop('checked', true);
});

$('[data-app-jquery-widget="restaurant-info"]').on('click', '[data-detail]', function(e) {
    $(e.delegateTarget).find('[data-toggle]').toggleClass('hidden');
});

(function() {
    function setPacking(packing) {
        $('#restaurant_packing').prop('checked', packing);
    }

    $('[data-app-jquery-widget="take-away"]').on('click', function(e) {
        setPacking(true);
    });

    $('[data-app-jquery-widget="in-restaurant"]').on('click', function(e) {
        setPacking(false);
    });
})();

$(document).on('click', '.fb-share-button', function(e) {
    let $target = $(e.currentTarget);
    window.open($target.data('href'), 'facebook-share-dialog', "width=600, height=400, scrollbars=no");
    return false;
});

$(document).on('click', '.timeout-banner .close', function() {
    $('.timeout-banner').addClass('timeout-banner--hidden');
});

$(document).on('click', '[data-toggle]', function(e) {
    let toggleTarget = e.currentTarget.dataset.toggleTarget;
    if (toggleTarget) {
        $('[data-toggle-target="' + toggleTarget +'"]').toggle();
    }
});

$(function() {
    const $remainingTimeElement = $('.remaining-time');
    if($remainingTimeElement.length !== 0) {
        const endTime = (parseInt($remainingTimeElement.html()) * 1000) + Date.now();
        // beware that `setInterval` is not guaranteed to run at exact specified interval
        const interval = setInterval(function() {
            const remainingMs = endTime - Date.now();
            const remainingS = Math.max(0, Math.floor(remainingMs / 1000));

            $('.remaining-time').html(remainingS);

            if(remainingS === 0) {
                window.location.reload();

                // make sure that reload won't end in a loop and the page actually reloads
                clearInterval(interval);
            }
        }, 200); // run in less than 1s so that countdown suddenly doesn't jump by 2
    }

});

$(function() {
    if (window.matchMedia != null && window.matchMedia("(orientation: portrait)").matches) {
        $('#product-config-phone-rotation').toggleClass('modal--active');
    }
});

window.addEventListener("orientationchange", function() {
    let $phoneRotationModal = $('#product-config-phone-rotation');
    if ($phoneRotationModal.hasClass('modal--active')) {
        $phoneRotationModal.removeClass('modal--active');
    }
});

$(document).on('click', '#phone-rotation-modal-close', function() {
    let $phoneRotationModal = $('#product-config-phone-rotation');
    $phoneRotationModal.removeClass('modal--active');
});

$('.phone-prefix').dropdown();

$(document).on('submit', 'form', function(e) {
    const form = e.currentTarget;
    if (e.currentTarget.classList.contains('loadable')) {
        $(this).addClass('loading');
    }
    const postShippingIntent = localStorage.getItem('post_shipping_intent');
    if (postShippingIntent) {
        try {
            const action = new URL(form.action);
            action.searchParams.append('post_shipping_intent', postShippingIntent);
            form.action = action.toString();
        } catch (error) {
            console.log(error);
        }
    }
});

$(document).on('submit', 'form.loadable', function() {
    $(this).addClass('loading');
});

$(document).on('submit', 'form.modal-form.form', function() {
    $(this).parents('.modal--active').coverWithLoader();
});

export function onLoadDom(containingEl) {
    $(containingEl).find('#form-login.login.login--active').each((index, el) => {
        $(el).loginForm();
    });
    $(containingEl).find('.ui.checkbox').checkbox();
    $(containingEl).find('.dropdown').dropdown();
    $(containingEl).activateDismissErrorsOnChange();
    $.fn.registerValidationErrors($(containingEl).find('.sylius-validation-error'));
    $.fn.registerValidationErrors($(containingEl).find('.custom-validation-error'));

    function onLoyaltyCardAlreadyMemberChange(alreadyMemberInput) {
        if (alreadyMemberInput.value === "0") {
            $('[name="sylius_customer_registration[loyaltyCard][cardNumber]"]').each(function() {
                $(this).prop('disabled', true);
                $(this.parentElement).hide2();
            });
        }
        if (alreadyMemberInput.value === "1") {
            $('[name="sylius_customer_registration[loyaltyCard][cardNumber]"]').each(function() {
                $(this).prop('disabled', false);
                $(this.parentElement).show2();
            });
        }
    }

    let loyaltyCardAlreadyMemberInput = $(containingEl).find('[name="sylius_customer_registration[loyaltyCard][alreadyMember]"]');
    if (loyaltyCardAlreadyMemberInput.length) {
        loyaltyCardAlreadyMemberInput.on('change input', function(e) {
            onLoyaltyCardAlreadyMemberChange(e.currentTarget);
        });
        let checkedInput = loyaltyCardAlreadyMemberInput.filter(':checked');
        if (checkedInput.length) {
            onLoyaltyCardAlreadyMemberChange(checkedInput[0]);
        }
    }

    if ($('[data-twisto-check-payload]').length) {
        $.fn.twistoCheck();
    }

    $(containingEl).find('.js-embedded-isic-form').on('submit', function(e) {
        e.preventDefault();
        $(this).submitViaAjax(function(response) {
            if (response.status) {
                let fieldsMap = {
                    firstName: 'checkout[shippingAddress][firstName]',
                    lastName: 'checkout[shippingAddress][lastName]',
                    isic: 'checkout[coupon][isic]',
                };
                for (let field in response.values) {
                    if (response.values.hasOwnProperty(field)) {
                        let input = $('[name="' + fieldsMap[field] + '"]');
                        input.val(response.values[field]);
                        if (field === 'isic') {
                            input.parent().show2();
                        }
                    }
                }
                $('#checkout_coupon_submit').click();
                $('.js-modal-close').click();
            }
            if (response.body) {
                onLoadDom($(e.currentTarget.parentElement).html($(response.body)));
            }
            $.fn.removeLoaders();
        });
    });

    $(containingEl).find('[data-submit-on-click]').on('click', function(e) {
        e.preventDefault();
        $(e.currentTarget.dataset.submitOnClick).submit();
    });

    webauthn.onLoad();
    dl.onLoad();
    paymentActions.onLoad(containingEl);
    forms.onLoad(containingEl);

    let carPositionMap = $('#order-shipping-car-position');
    if (window.mapboxgl && carPositionMap.length) {
        initOrderTracking(window.mapboxgl, carPositionMap);
    }

    let shippingProgress = $('#order-shipping-progress');
    if (shippingProgress.length) {
        initShippingProgress(shippingProgress);
    }

    (function() {
        const currentUrl = new URL(window.location.href);
        const productToEmphasize = currentUrl.searchParams.get('emphasize_product');
        if (productToEmphasize) {
            let productButton = $('button[data-product-id="' + productToEmphasize + '"');
            let productCard = productButton.parents('li.product');
            productCard[0].querySelector('.scroll-point').scrollIntoView();
            productCard.find('.product__img').click();
        }

        if (document.referrer) {
            const referrer = new URL(document.referrer);
            if (referrer.searchParams.has('post_shipping_intent') &&
                !currentUrl.searchParams.has('post_shipping_intent')
            ) {
                localStorage.removeItem('post_shipping_intent');
            }
        }
    })();

    window.appOnLoadDom = onLoadDom;
}

// sylius needs to run it's onready stuff first hopefully (input.search is being created by semantic.ui)
$(document).ready(function() {
    initPushNotifications();
    (() => {
        const backButton = $('#back-button');
        if (backButton.length &&
            document.referrer &&
            window.location &&
            document.referrer.indexOf(window.location.origin) === 0
        ) {
            backButton.show();
        }
    })();
    $('.taxon-chunk').first().each(function() {
        if (isLargeScreen()) {
            //window.scrollTo(0, $('header')[0].offsetHeight);
        } else {
            //window.scrollTo(0, $('header')[0].offsetHeight * 1.5);
        }
    });
    let saveMoneyWithPersonalPickupBanner = $('.js-save-money-with-personal-pickup-banner');
    if (saveMoneyWithPersonalPickupBanner.length) {
        $.get({
            url: saveMoneyWithPersonalPickupBanner.data('url'),
            success: (response) => {
                if (response.status) {
                    $('.js-saved-money').text(response.saved);
                    saveMoneyWithPersonalPickupBanner.show();
                }
            }
        })
    }
    if ('scrollRestoration' in history) {
        history.scrollRestoration = $('[data-scroll-restoration]').data('scroll-restoration') || 'auto';
    }
    if ($('[data-scroll-to-top-on-ready="1"]').length) {
        setTimeout(() => window.scrollTo(0, 0), 250);
    }

    const carouselNav = $('#carousel-nav');
    const primaryNav = $('#primary-nav');

    if (carouselNav.length) {
        carouselNav.carouselMenu();
    }

    if (primaryNav.length) {
        primaryNav.primaryMenu();
    }

    function markHeadings(headings, scrollIntoView = true) {
        $(headings).each(function() {
            const menuItems = $('[data-taxon-anchor="' + this.id + '"]');
            if (menuItems.length &&
                window.scrollY + (window.innerHeight * 0.3) > this.offsetTop
            ) {
                menuItems.each(function() {
                    let taxon = null;
                    if (carouselNav.length && $(this).parent('.carousel-items').length && carouselNav.css('display') !== 'none') {
                        taxon = this;
                        carouselNav.trigger('set-active-carousel-item', { item: this, scrollIntoView });
                    }
                    if (primaryNav.length && $(this).parent('.nav-list').length && primaryNav.css('display') !== 'none') {
                        taxon = this;
                        primaryNav.trigger('set-active-menu-item', { item: $(this).children('a')[0] });
                    }
                    if (taxon && taxon.dataset) {
                        document.dispatchEvent(new CustomEvent(dl.DISPLAYED_PRODUCT_LIST_CHANGE, { detail: { id: taxon.dataset.taxonAnchor } }));
                    }
                });
                return false; // break loop
            }
        });
    }
    function getHeadings() {
        return $('.heading-h1').map(function() {
            return this;
        }).toArray().reverse();
    }
    let headings = getHeadings();
    function updateHeadings() {
        headings = getHeadings();
        markHeadings(headings, false);
    }

    // removing all validation error messages on new user input
    let validationErrors = $('.sylius-validation-error').add($('.custom-validation-error'));
    $.fn.registerValidationErrors(validationErrors);

    let shippingContent = $('#shipping-content');
    if (shippingContent.length && ! shippingContent.isInViewport() && window.location.search.indexOf('shipping_content=') > 0) {
        shippingContent[0].scrollIntoView();
        window.scrollBy(0, ($('header.head').outerHeight() + 20) * -1);
    }

    let cookiesAckButton = $('#cookies-ack-button');
    if (cookiesAckButton.length) {
        cookiesAckButton.on('click', function() {
            $('#cookies-ack-bar').remove();
            let now = new Date();
            now.setMonth(now.getMonth() + 1);
            document.cookie = "cookies-usage-ack=1; expires=" + now.toUTCString() + "; path=/";
        });
    }

    const cookiePromptRootElement = document.querySelector('#cookies-ack-bar');
    if (null !== cookiePromptRootElement) {
        (new CookiePrompt(cookiePromptRootElement, $.ajax)).init();
    }

    let topMostError;
    validationErrors.each(function() {
        if ($(this).is(':visible')) {
            if (!topMostError) {
                topMostError = this;
            } else if ($(topMostError).offset().top > $(this).offset().top) {
                topMostError = this;
            }
        }
    });
    if (topMostError) {
        topMostError.scrollIntoView(true);
        window.scrollBy(0, ($('header.head').outerHeight() + topMostError.offsetHeight) * -1.7);
    }

    (function() {
        let contactBranchSelect = $('[data-js-contact-branch-select="1"]');
        let contactCitySelect = $('[data-js-contact-city-select="1"]');

        if (contactBranchSelect.length && contactCitySelect.length) {

            let onCityChange = function() {
                let city = contactCitySelect.val();
                if (city.length) {
                    contactBranchSelect.find('option').each(function() {
                        $(this).data('city') === city ? $(this).show() : $(this).hide();
                    });
                } else {
                    contactBranchSelect.find('option').each(function() {
                        $(this).show();
                    });
                }
                let branchCity = contactBranchSelect.find(':selected').data('city');
                branchCity && branchCity !== city && contactBranchSelect.val('');
            };

            let onBranchChange = function() {
                let city = contactBranchSelect.find(':selected').data('city');
                city && city.length && contactCitySelect.val(city);
            };

            contactCitySelect.on('change', onCityChange);
            contactBranchSelect.on('change', onBranchChange);
            onCityChange();
        }
    }());

    $('[data-modal="#modal-no-shipment"]').click(function() {
        $('form.loading').removeClass('loading');
    });

    (function() {
        var form = $('form [data-submit-immediately=1]').parents('form');
        if (form.length) {
            form.hasClass('loading') || form.addClass('loading');
            form.submit();
        }
    })();

    $('#js-submit-order-remove-unavailable-items').click(function() {
        var input = $('[data-remove-unavailable-items=1]');
        input.val(1);
        input.parents('form')[0].submit();
    });

    $('.js-submit-cart-form').click(function() {
        $('form[name="checkout"]')[0].submit();
    });

    $('.js-cancel-form-loading').click(function() {
        $('form.loading').removeClass('loading');
    });

    $('form[data-xhr="1"]').each(function() {
        $(this).submit(function(e) {
            e.preventDefault();
            $.post(this.action, $(this).serialize()).then(this.onXhrResponse);
        });
    });

    // removing loading classes from form when page is loaded via back-forward cache
    window.addEventListener('pageshow', function(e) {
        if (e.persisted) {
            $('form.loading').each(function() {
                $(this).removeClass('loading');
            });
            if (document.body.dataset.bfCacheReload) {
                window.reload();
            }
        }
    });
    (function() {
        let taxonListControls = [];
        let isTaxonLoaded = (code) => {
            return taxonListControls.reduce((results, control) => {
                results.push(control.isLoaded(code))
                return results;
            }, []).filter((a) => !!a).length;
        };
        let insertAll = () => {
            taxonListControls.forEach((control) => {
                control.insertAll();
            });
        };
        let abortAll = () => {
            taxonListControls.forEach((control) => {
                control.abort();
            });
        };
        window.addEventListener('popstate', function(event) {
            if (event.state && event.state.taxonLinkId && document.getElementById(event.state.taxonLinkId)) {
                window._suppressPushState = true;
                document.getElementById(event.state.taxonLinkId).click();
            }
        });
        let lastTop;
        let firstDisplayedTaxon = {
            el: $('h1.heading-h1.product-heading').get(0),
            lastY: undefined
        };
        if (firstDisplayedTaxon.el) {
            let taxonLinkId;
            if (isPrimaryNavHidden()) {
                taxonLinkId = document.querySelector('.current-category').children.item(0).id;
            } else {
                taxonLinkId = document.querySelector('.nav-item__link--active').id;
            }
            window.history.replaceState({ taxonLinkId: taxonLinkId }, null, window.location.href);
        }
        $('[data-taxon-anchor] a').click(function(e) {
            let anchor = e.currentTarget.parentElement.dataset.taxonAnchor;
            if (anchor) {
                let el = document.getElementById(anchor);
                if (el) {
                    e.preventDefault();
                    let href = e.currentTarget.href;
                    if (href && !window._suppressPushState) {
                        window.history.pushState({ taxonLinkId: this.id }, null, href);
                    }
                    window._suppressPushState = false;
                    el.scrollIntoView(true);
                    let scrollBy = $(el).outerHeight() * 0.5;
                    if ($(this.parentElement).parent('.carousel-items').length) {
                        scrollBy += $('body').hasClass('body--scroll') ? 88 : 242; // both headers and navs heights change
                    } else {
                        scrollBy += $('header.head').outerHeight();
                    }
                    window.scrollBy(0, scrollBy * -1);
                } else {
                    if (isTaxonLoaded(anchor)) {
                        e.preventDefault();
                        insertAll();
                        e.currentTarget.click();
                    } else {
                        abortAll();
                    }
                }
            }
        });
        function beforeInsert(mode) {
            if (mode === 'prepend') {
                lastTop = window.scrollY;
                if (firstDisplayedTaxon.el) {
                    firstDisplayedTaxon.lastY = firstDisplayedTaxon.el.getBoundingClientRect().y;
                }
            }
        }
        function afterInsert(mode, element) {
            if (mode === 'prepend' &&
                lastTop !== undefined &&
                (
                    isIOS() || // always scrollTo when on iOS
                    window.scrollY === 0 || // browser is going to keep the window.scrollY at 0 after insertions
                    (
                        firstDisplayedTaxon.el &&
                        Math.abs(firstDisplayedTaxon.lastY - firstDisplayedTaxon.el.getBoundingClientRect().y) > 50
                        // and sometimes browser is going to do whatever it wants so when it shifts the content by 50
                        // lets adjust the scrollY,...
                    )
                )
            ) {
                window.scrollTo(window.scrollX, lastTop + element.offsetHeight);
            }
            updateHeadings();
            onLoadDom(element);
        }
        let dfd;
        $('[data-lazy-list-type="lower"]').each(function() {
            dfd = $.Deferred();
            taxonListControls.push($(this).taxonList(beforeInsert, (unpauseInsertion) => {
                return (mode, element) => {
                    afterInsert(mode, element);
                    (dfd.state() !== 'resolved') && dfd.resolve();
                    unpauseInsertion();
                };
            }));
        });
        $('[data-lazy-list-type="upper"]').each(function() {
            taxonListControls.push($(this).taxonList(beforeInsert, (unpauseInsertion) => {
                return (mode, element) => {
                    afterInsert(mode, element);
                    unpauseInsertion();
                };
            }, dfd ? dfd.promise() : undefined));
        });
    })();

    (function() {
        function delayedScrollFactory(pixels, callback) {
            let lastTop = 0;
            return function() {
                if (Math.abs(window.scrollY - lastTop) > pixels) {
                    lastTop = window.scrollY;
                    callback();
                }
            };
        }
        markHeadings(headings);
        $(window).resize(function() {
            headings = getHeadings();
        });
        let delayedScroll = delayedScrollFactory(50, function() {
            markHeadings(headings);
        });
        // -- Sticky navbar
        $(window).scroll(function(event) {
            delayedScroll();

            var set_fixed = BODY_SCROLL_THRESHOLD;
            var y = $(this).scrollTop();
            var $body = $('body');
            if (y >= set_fixed && !$body.hasClass('body--scroll')) {
                $body.addClass('body--scroll');
            } else if (y < set_fixed && $body.hasClass('body--scroll')) {
                $body.removeClass('body--scroll');
            }

            // just in case of not scrolled
            if(!$(window).scrollTop()) { // abuse 0 == false
                $(function () {
                    var onResize = function () {
                        var docHeight = $(window).innerHeight();
                        if ($(window).innerWidth() <= 767.98) {
                            $('#mobile-container').css({ height: docHeight });
                        } else {
                            $('#mobile-container').css({ height: '' });
                        }
                    };
                    $(window).on('resize', onResize);
                    onResize();
                });
            }
        });
    })();
});

(function() {
    function highlightSelectedPastry($container) {
        $container.find('[data-pastry-item]:has(input:not(:checked))').removeClass('item-active');
        $container.find('[data-pastry-item]:has(input:checked)').addClass('item-active');
    }

    const $pastryItems = $('[data-pastry-item]');
    $(document).on('change', '[data-pastry-item]', function(e) {
        const $container = $(this).parent();
        highlightSelectedPastry($container);
    });

    $pastryItems.parent().each(function() {
        highlightSelectedPastry($(this));
    });
    const scoreInputs = $('[name="order_score[productScore]"]').add($('[name="order_score[deliveryScore]"]'));
    scoreInputs.each(function() {
        if (this.value) {
            $('.js-score-' + this.name.match(/\[(.+)Score\]/)[1] + ' .js-score-' + this.value).addClass('clicked');
        }
    });

    $('form[name="order_score"]').submit(function(e) {
        scoreInputs.each(function() {
            if (!this.value) {
                e.preventDefault();
                e.stopPropagation();
                $('[data-field-full-name="' + this.name + '"].custom-validation-error').show();
            }
        });
    });

    $(document).on('click', '[data-forward-click]', function(e) {
        var target = $($(e.currentTarget).data('forward-click'));
        target.removeAttr('data-modal');
        target.click();
    });

    onLoadDom(document.body);
})();

/**
 * Handles also event creation in IE11.
 */
function createEvent(name, bubbles, cancelable) {
    if (typeof Event === 'function') {
        return new Event('input', {bubbles: bubbles, cancelable: cancelable});
    }

    const event = document.createEvent('Event');
    event.initEvent(name, bubbles, cancelable);

    return event;
}

// customer satisfaction score
$(document).on('click', '.js-score-product [class^="score-icon js-score-"]', function() {
    const score = this.className.match(/js-score-(\d+)/)[1];
    const element = document.getElementById(this.parentElement.dataset.scoreInputId);
    element.value = score;
    element.dispatchEvent(createEvent('input', true, true));
    $('.js-score-product [class^="score-icon js-score-"]').removeClass('clicked');
    $('.js-score-product .js-score-' + score).addClass('clicked');
});

$(document).on('click', '.js-score-delivery [class^="score-icon js-score-"]', function() {
    const score = this.className.match(/js-score-(\d+)/)[1];
    const element = document.getElementById(this.parentElement.dataset.scoreInputId);
    element.value = score;
    element.dispatchEvent(createEvent('input', true, true));
    $('.js-score-delivery [class^="score-icon js-score-"]').removeClass('default');
    $('.js-score-delivery [class^="score-icon js-score-"]').removeClass('clicked');
    $('.js-score-delivery .js-score-' + score).addClass('clicked');
});

// prevent doubletap zooming on mobile
var doubleTouchStartTimestamp = 0;
$(document).bind("touchstart", function(event){
    var now = +(new Date());
    if (doubleTouchStartTimestamp + 500 > now){
        event.preventDefault();
    }
    doubleTouchStartTimestamp = now;
});

function isPrimaryNavHidden() {
    return window.getComputedStyle(document.getElementById('primary-nav')).display === 'none';
}
